module.exports = __webpack_public_path__ + "static/media/kontaktlinsen04.dca576c7.jpg";